<template>
    <div class="plist-box">
        <bread-crumb></bread-crumb>
        <!-- 筛选条件 -->
        <plist-filter>
            <template #category>
                <plist-filter-list
                    :list-title="$t('message.plist.category')"
                    :list-data="subcate"
                    @handleClick="arg => handleFilter(arg, brand_id)">
                </plist-filter-list>
            </template>
            <template #brand>
                <plist-filter-list
                    :list-title="$t('message.plist.brand')"
                    :list-data="brand"
                    @handleClick="arg => handleFilter(id, arg)">
                </plist-filter-list>
            </template>
        </plist-filter>
        <plist-content
            :display-mode="display_mode">
            <!-- 显示控制 -->
            <template #sort>
                <plist-display-control
                    v-model="display_mode"
                    :sort="sort"
                    @handleSort="handleSort">
                </plist-display-control>
            </template>
            <!-- 分页 -->
            <template #pagination>
                <div class="plist-pagination">
					<el-pagination
					  @size-change="handleSizeChange"
					  @current-change="handlePage"
					  :current-page.sync="commodityPage.current_page"
					  :page-size="commodityPage.per_page"
					  layout="prev, pager, next, jumper"
					  :total="commodityPage.total"
					  background>
					</el-pagination>
                </div>
            </template>
        </plist-content>
        <plist-recommend></plist-recommend>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return {
			currentPage2:0,
            search: '',
            id: '',
            brand_id: '',
            sort: '',
            priority: '',
            display_mode: true,
        }
    },
    computed: mapState({
        subcate: state => state.goods.subcate,
        brand: state => state.goods.brand,
        currentPage: state => state.goods.currentPage,
        pageSize: state => state.goods.pageSize,
        pageSizes: state => state.goods.pageSizes,
        pageCount: state => state.goods.pageCount,
		commodityPage: state => state.goods.commodityPage,
		
    }),
    components: {
        breadCrumb: () => import("@/components/breadCrumb"),
        plistFilter: () => import('@/components/plistFilter'),
        plistFilterList: () => import('@/components/plistFilterList'),
        plistDisplayControl: () => import('@/components/plistDisplayControl'),
        plistContent: () => import("@/components/plistContent"),
        plistRecommend: () => import("@/components/plistRecommend")
    },
    watch: {
        $route: {
            handler: function (route) {
                let { id = '', brand = '', search = '', sort = '' } = route.query,
                    { priority = '' } = route.params;
                this.search = search;
                this.id = id;
                this.brand_id = brand;
                this.priority = priority;
                this.sort = sort;
            },
            immediate: true
        },
        pageSize(){
            document.body.scrollTop=document.documentElement.scrollTop=window.pageYOffset=0
        }
    },
    methods: {
        ...mapActions([
            'getBreadCrumb',
            'getSubcateBrand',
            'getPlist',
            'getRecommend',
        ]),
        handleFilter(id, brand) {
            let priority = this.priority;
            if(id === '' || brand === '') priority = '';
            this.$router.push({
                name: 'plist',
                query: {
                    id,
                    brand,
                    search: this.search,
                    sort: this.sort,
                },
                params: {
                    priority
                }
            }).catch(err => {err})
        },
        handleSort({ up, down }) {
            let sort = '';
            sort = this.sort == down? up: down;
            this.$router.push({
                name: 'plist',
                query: {
                    id: this.id,
                    brand: this.brand_id,
                    search: this.search,
                    sort
                }
            }) 
        },
        handleSizeChange(val){ // 页显示条数更改
            let { id = "", brand = "", search = "", sort = "" } = this.$route.query;
            let { priority = "" } = this.$route.params;
            this.getPlist({
                id,
                brand,
                search,
                priority,
                sort,
                number: val
            })
        },
        handlePage(val){ // 更改当前页
            let { id = "", brand = "", search = "", sort = "" } = this.$route.query;
            let { priority = "" } = this.$route.params;
            this.getPlist({
                id,
                brand,
                search,
                priority,
                sort,
                page:val,
                number: this.pageSize
            })
        }
    },
    beforeRouteEnter (to, from, next) {
        // ...
        next(vm => {
            // 获取路由参数
            let { id = '', brand = '', search = '', sort = '' } = to.query;
            let { priority = '' } = to.params;

            vm.getBreadCrumb(id);
            vm.getSubcateBrand({
                id,
                search,
                brand,
                priority
            })
            vm.getPlist({
                id,
                brand,
                search,
                sort,
                priority,
            }); // 商品列表内容请求
            vm.getRecommend(); // 推荐商品获取
        })
    },
    beforeRouteUpdate (to, from, next) {
        // 获取路由参数
        let { id = '', brand = '', search = '', sort = '' } = to.query;
        let { priority = '' } = to.params;

        this.getBreadCrumb(id);
        this.getSubcateBrand({
            id,
            search,
            brand,
            priority
        })
        this.getPlist({
            id,
            brand,
            search,
            sort,
            priority,
            number: this.pageSize
        }); // 商品列表内容请求
        next()
    }
}
</script>

<style>
/* 组件盒子 */
.plist-box{
    background-color: #f5f5f5;
    min-width: 1200px;
}
.plist-pagination {
    display: flex;
    justify-content: flex-end;
    margin: 30px 0;
}
</style>
